<!-- 预售说明弹窗 -->
<template>
  <cc-bottom-popup
    :autoHeight="true"  v-bind="$attrs" v-on="$listeners"
    :showBtn="false"
    :height="556"
    title="预售说明"
  >
    <div class="presell-popup-content">
      <h1>预售规则：</h1>
      <p>1.预售定金下单后，请在限期内付款。若超时，该订单将自动关闭。</p>
      <p>2.预售商品可选择先支付定金，也可选择一次性支付全款。 具体以商品详情页及下单页展示为准。</p>
      <p>3.定金付款后，若非商家违约导致交易未完成的，定金恕不退还。</p>
      <p>4.定金支付完成后请至“预售订单”中“尾款待付”订单查找所要支付尾款的订单。</p>
      <p>5.用户可在“我的订单”中进行尾款支付，请在规定时间内支付尾款。若超时，系统将自动关闭订单，且定金不退还。还请注意预售结束时间，关注短信，及时支付尾款。</p>
      <p>6.发货时间请以预售商品详情页中“发货时间”描述为准。</p>
      <p>7.如您对活动有任何疑问，请联系客服咨询。</p>
      <h1>预售相关违约定义：</h1>
      <p>A、 用户违约</p>
      <p>以下几种情况均视为用户违约 </p>
      <p>在指定的定金支付时间内，用户没有足额支付定金（因支付系统允许分次支付导致）；</p>
      <p>在指定的尾款支付时间内，用户已经支付了定金，但未支付尾款；</p>
      <p>在指定的尾款支付时间内，用户已经支付了定金，但没有足额支付尾款（因支付系统允许分次支付导致）；</p>
      <p>前2种情况定金恕不退还，第3种情况定金不退还，超出定金的部分的尾款退还。</p>
      <p>B、 商家违约</p>
      <p>在预售期间，如果商家提出关闭预售，则视为用户商家违约，商家违约时，按用户实际支付的款项全额退还。</p>
    </div>
  </cc-bottom-popup>
</template>
<script>
export default {
  name: 'presell-explain',
  data () {
    return {}
  }
}
</script>
<style lang='scss' scoped>
/* 预售说明弹窗 */
.presell-popup-content{
  color: #333333;
  padding: 15px;
  p{
    line-height: 24px;
    font-size: 12px;
  }
  h1{
    font-size: 13px;
    font-weight: bold;
  }
}
</style>
